import React, { FC } from 'react'

import { LinkButton } from 'mf-ui-components'

import {
  CarouselItemContainer,
  Description,
  Image,
  Title,
} from './CarouselItem.styles'
import { LightCarouselSettings, Slide } from './types'

type Props = Slide & Pick<LightCarouselSettings, 'imageShape'>

export const CarouselItem: FC<Props> = ({
  title,
  description,
  image,
  imageShape,
  cta,
}) => (
  <CarouselItemContainer>
    {!!image?.url?.length && (
      <Image
        src={image.url}
        alt={image.alt || image.title || title}
        title={image.title}
        imageShape={imageShape}
      />
    )}

    <Title>{title}</Title>
    <Description dangerouslySetInnerHTML={{ __html: description }} />

    {!!cta?.label?.length && (
      <LinkButton role={cta.role} inverted={!!cta.inverted} href={cta.target} style={{
        marginTop: 32
      }}>
        {cta.label}
      </LinkButton>
    )}
  </CarouselItemContainer>
)
